import styles from './DownloadApp.module.css';
import { PiAndroidLogoBold } from "react-icons/pi";
import { AiOutlineApple } from "react-icons/ai";


/**
 * 모방리 앱 다운로드 화면
 * @returns {JSX.Element}
 * @constructor
 */
function DownloadApp() {

    return (
        <div className={styles.download}>
            <div className={styles.download__box}>
                <div className={styles.download__logo} />
                <h3>모바일 어플리케이션 다운로드 페이지</h3>
                <button className={styles.download__btn}>
                    <PiAndroidLogoBold />
                    <p><a className={styles.download__btn__text} id="downlink" href="http://update.touchxcloud.com:11280/core_file/deepsleep.apk">안드로이드</a></p>
                </button>
                <button className={`${styles.download__btn} ${styles.ios}`} disabled={true}>
                    <AiOutlineApple />
                    <p className={styles.download__btn__text}>iOS (준비중)</p>
                </button>
            </div>
        </div>
    )
}

export default DownloadApp;